import { DateTimeString, getDateTimeString } from "../../dateTypes.js";
import { CellExecutionState } from "../../enums.js";
import { AppSessionCellId, CellId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const CREATE_APP_SESSION_CELL = createAppSessionEventDefinition({
  type: "CREATE_APP_SESSION_CELL",
  logSafe: {
    cellId: true,
    appSessionCellId: true,
    state: true,
    lastExecutionEndTime: true,
    lastExecutionStartTime: true,
  },
  create: ({
    lastExecutionEndTime,
    lastExecutionStartTime,
    ...rest
  }: {
    appSessionCellId: AppSessionCellId;
    cellId: CellId;
    state?: CellExecutionState;
    lastExecutionEndTime?: Date | DateTimeString | null;
    lastExecutionStartTime?: Date | DateTimeString | null;
  }) => ({
    lastExecutionEndTime:
      lastExecutionEndTime instanceof Date
        ? getDateTimeString(lastExecutionEndTime)
        : lastExecutionEndTime,
    lastExecutionStartTime:
      lastExecutionStartTime instanceof Date
        ? getDateTimeString(lastExecutionStartTime)
        : lastExecutionStartTime,
    ...rest,
  }),
  apply: ({
    indices,
    payload: {
      appSessionCellId,
      cellId,
      lastExecutionEndTime,
      lastExecutionStartTime,
      state: cellState,
    },
    state,
  }) => {
    const warnings: string[] = [];

    if (state.appSessionCells[appSessionCellId] != null) {
      warnings.push(
        `App session cell previously existed, overwriting: ${appSessionCellId}`,
      );
    }

    state.appSessionCells[appSessionCellId] = {
      id: appSessionCellId,
      cellId,
      state: cellState ?? CellExecutionState.IDLE,
      lastExecutionEndTime: lastExecutionEndTime ?? null,
      lastExecutionStartTime: lastExecutionStartTime ?? null,
      lastExecutionTraceId: undefined,
      lastRunSourceRevision: undefined,
      lastRunStateRevision: undefined,
      lastRunExecutionRevision: undefined,
    };

    indices.cellIdToAppSessionCellId[cellId] = appSessionCellId;
    indices.appSessionCellIdToOutputIds[appSessionCellId] = [];

    return { warnings };
  },
});
